<template>
  <div class="box">
        <headTail current='活动资讯'></headTail>
        <div class="box-ceng">
            <div class="fonsit" @click="tiao()">
              〈 返回列表
            </div>
            <div>
              <div class="nuyt">
                <div class="nut-zi" style="font-size: 22px;">{{item2}}</div>
                <div class="nut-zi2" style="font-size: 17px;">{{item.substring(0,11)}}</div>
              </div>
              
                 <div class="nuyt" v-html="lists">
             </div>
            </div>
            
        </div>
          <headBar></headBar>
       
  </div>
</template>
<script>
import { isElementNotInViewport} from "@/util/index.js";
import * as config from "@/util/berurl.js";
import qs from 'qs'
export default {
  name: 'HelloWorld',
  data () {
    return {
      item2:'',
      item:'',
      lists:{},
      api:config.basePath,
      userId:'',
      banquanType:2,
      isFixed:false,//大赛介绍
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
  },
  created() {
    //  if(this.$route.query.id) {
      //  this.userId = this.$router.query.id
       console.log('jj',this.$route.query.id)
    // }
  },
  mounted() {
    if(this.$route.query.id) {
      this.list()
    }
    this.getpoint()
  },
  methods:{
      getpoint(){	
				var local = window.location.href; // 获取页面url
				this.$axios({
					url: this.api+'api-cms/notAuth/activity/point',
					method: 'post',
		      headers: { 'content-type': 'application/x-www-form-urlencoded' },
			  data: qs.stringify({reqPageUrl: local}),
						
				}).then((res) =>{ 

        })
    },
    list() {
      
        // console.log('数据',this.api +'api-cms/cmsOfflineNews/getOfflineNews/'+this.$route.query.id) 
        this.$axios({
                method:'GET',
                url: this.api+'api-cms//notAuth/cmsOfflineNews/getOfflineNews/'+this.$route.query.id,
            }).then((res) =>{    
              
              if(res.data.code==200) {
                  
                // this.total = res.data.data.total 
                this.lists = res.data.data.content
                 console.log('数据',this.lists) 
                 this.item = res.data.data.activityTime
                 this.item2 = res.data.data.title
                //  console.log('数据3',res.data.data.total)   
              }   
               
            })
    },
    tiao() {
       this.$router.push('/news') 
    }
  }
}
</script>
<style >
/* ::v-deep.wscnph{
 max-width: 300px !important;
} */
/deep/img{
	max-width: 100% !important;
	}
img{
  max-width: 100%;
}
.wscnph{
   width: 970px !important;
   /* height: 513px !important; */
}
</style>
<style scoped>
.nut-zi{
  color: #333333;
  font-weight: 400;
  margin-bottom: 27px;
}
.nut-zi2{
  color: #333333;
  margin-bottom: 61px;
  /* font-weight: 400; */
}
.xin{
  font-size: 28px;
  color: #333333;
}
.box-img22{
  margin-bottom: 180px;
}
.nuyt{
  text-align: left;
  padding-left: 618px;
  font-size: 30px;
  margin-left: 41px;
}
.news-biao3{
  color: #666666;
  font-size: 24px;
   margin-top: 50px;
   margin-bottom: 63px;
 
}
.news-biao{
  color: #333333;
  font-size: 32px;
  
}

.news-biao2{
  color: #999999;
  font-size: 24px;
  margin-bottom: 52px;
  margin-top: 27px;

}
.fonsit:hover{
  cursor:pointer
}
.fonsit{
  text-align: initial;
  /* width: 31%; */
  color: #333333;
  font-size: 28px;
  /* padding-left: 387px;
  padding-right: 115px; */
  position: absolute;
  left: 387px;
  /* height: 100%; */
  padding-right: 73px;
   /* border-right: 1px solid #F5F5F5;  */
  /* height: calc(100% - 92px) ; */
  height: auto;
  /* height: 100%; */
}
.box{
  width: 1920px;
  
 
}
.box-ceng{
  padding-top: 48px;
  /* align-items: center; */
  /* background: yellow; */
  padding-right: 335px;
  /* margin-bottom: 92px; */
  padding-bottom: 92px;
    /* position: relative; */
   background: url(../image/huod2.png) no-repeat ;
 background-size:cover;
background-attachment:fixed;


  /* background-size:100% 100%; */
  /* height: 1400px; */
  /* background-size: 100% 100%; */
}
/* .box-ceng{

  margin-top: 48px;
  padding-right: 335px;
  background: url(../image/huod2.png) no-repeat ;
  background-size:100% 100%;
  padding-top: 324px;
  padding-left: 723px;
  padding-right: 722px;
  padding-bottom: 395px;
  background-size: cover;
} */
</style>


// WEBPACK FOOTER //
// src/components/activityDetails.vue